var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 188,
    viewBox: "0 0 188 188",
    width: 188,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m187.968 94c0-51.9154-42.077-94-93.9838-94-51.9054 0-93.9842 42.0846-93.9842 94 0 51.915 42.0788 94 93.9842 94 51.9068 0 93.9838-42.085 93.9838-94z",
    fill: "#e89806"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m99.9523 109.789h-11.9364c-2.3638 0-4.2801-1.916-4.2801-4.281v-54.0498c0-2.3652 1.9163-4.2814 4.2801-4.2814h11.9364c2.3637 0 4.2817 1.9162 4.2817 4.2814v54.0498c0 2.365-1.916 4.281-4.2817 4.281z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.9841 143.866c-5.6599 0-10.2483-4.59-10.2483-10.25v-.003c0-5.66 4.5884-10.25 10.2483-10.25s10.2499 4.59 10.2499 10.25v.003c0 5.66-4.59 10.25-10.2499 10.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastWarningIcon);
export default __webpack_public_path__ + "static/media/toast-warning-icon.0d016b71a9507007d98bd7f79dbb9aea.svg";
export { ForwardRef as ReactComponent };